import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e1fdfd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Direction" }
const _hoisted_2 = {
  key: 4,
  class: "Direction__box Container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении детальной информации произошла ошибка", -1))
const _hoisted_4 = { key: 5 }
const _hoisted_5 = { class: "flex items-center justify-between mb-9" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = {
  key: 0,
  class: "HintHolder"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Hint" }, "Родительское направление", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "Direction__actions" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_14 = { class: "Direction__main" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Direction__subtitle mb-3" }, "Основная информация", -1))
const _hoisted_16 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_17 = { class: "flex items-center whitespace-nowrap" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "flex items-center whitespace-nowrap" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { class: "flex items-center whitespace-nowrap" }
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { key: 5 }
const _hoisted_26 = { class: "flex items-center whitespace-nowrap" }
const _hoisted_27 = { class: "flex items-center whitespace-nowrap" }
const _hoisted_28 = {
  key: 6,
  class: "flex items-center whitespace-nowrap"
}
const _hoisted_29 = {
  key: 7,
  class: "flex items-center flex-wrap"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "flex items-center whitespace-nowrap" }
const _hoisted_32 = {
  key: 0,
  class: "Direction__box Direction__sla"
}
const _hoisted_33 = { class: "flex items-center justify-between mb-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Direction__subtitle" }, "SLA", -1))
const _hoisted_35 = { class: "overflow-auto" }
const _hoisted_36 = {
  key: 0,
  class: "Direction__table"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-white text-black font-bold" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Тариф"),
    /*#__PURE__*/_createElementVNode("th", null, "Период"),
    /*#__PURE__*/_createElementVNode("th", null, "Забор"),
    /*#__PURE__*/_createElementVNode("th", null, "Обработка"),
    /*#__PURE__*/_createElementVNode("th", null, "Транзит"),
    /*#__PURE__*/_createElementVNode("th", null, "Доставка")
  ])
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "font-semibold align-middle",
  rowspan: "2"
}, "Стандарт", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Летнее время", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Зимнее время", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "font-semibold align-middle",
  rowspan: "2"
}, "Экспресс", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Летнее время", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Зимнее время", -1))
const _hoisted_44 = {
  key: 1,
  class: "Direction__table"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-white text-black font-bold" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Тариф"),
    /*#__PURE__*/_createElementVNode("th", null, "Период"),
    /*#__PURE__*/_createElementVNode("th", null, "Забор"),
    /*#__PURE__*/_createElementVNode("th", null, "Обработка"),
    /*#__PURE__*/_createElementVNode("th", null, "Транзит"),
    /*#__PURE__*/_createElementVNode("th", null, "Доставка")
  ])
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "font-semibold align-middle",
  rowspan: "2"
}, "Стандарт", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Летнее время", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Зимнее время", -1))
const _hoisted_49 = {
  key: 0,
  class: "Direction__box mt-3"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Direction__subtitle mb-3" }, "Нормы загруженности", -1))
const _hoisted_51 = { class: "overflow-auto" }
const _hoisted_52 = { class: "Direction__table" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-white text-black font-bold" }, [
    /*#__PURE__*/_createElementVNode("th", null, "20-тонник"),
    /*#__PURE__*/_createElementVNode("th", null, "10-тонник"),
    /*#__PURE__*/_createElementVNode("th", null, "5-тонник"),
    /*#__PURE__*/_createElementVNode("th", null, "3-тонник"),
    /*#__PURE__*/_createElementVNode("th", null, "Газель")
  ])
], -1))
const _hoisted_54 = { class: "flex items-center justify-between" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Вес:", -1))
const _hoisted_56 = { class: "flex items-center justify-between" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Кубатура:", -1))
const _hoisted_58 = {
  key: 1,
  class: "Direction__box mt-3"
}
const _hoisted_59 = { class: "flex items-center justify-between" }
const _hoisted_60 = { class: "flex items-center" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Direction__subtitle mr-2" }, "Дочерние направления", -1))
const _hoisted_62 = { class: "Direction__counter" }
const _hoisted_63 = { class: "Direction__actions HintHolder" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_65 = {
  key: 0,
  class: "Hint HintButtons"
}
const _hoisted_66 = {
  key: 0,
  class: "InternationalDirections mt-3"
}
const _hoisted_67 = { class: "min-w-full" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "text-center font-semibold" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Наименование"),
    /*#__PURE__*/_createElementVNode("th", null, "Код 1С"),
    /*#__PURE__*/_createElementVNode("th", null, "Зона доставки"),
    /*#__PURE__*/_createElementVNode("th", null, "Логист"),
    /*#__PURE__*/_createElementVNode("th", null, "Статус"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_69 = { class: "text-sm" }
const _hoisted_70 = { class: "Direction__link" }
const _hoisted_71 = { class: "flex justify-center" }
const _hoisted_72 = {
  key: 0,
  class: "Direction__counter"
}
const _hoisted_73 = { class: "MainText" }
const _hoisted_74 = {
  key: 0,
  class: "Hint"
}
const _hoisted_75 = {
  key: 2,
  class: "Direction__box mt-3"
}
const _hoisted_76 = { class: "flex items-center justify-between" }
const _hoisted_77 = { class: "flex items-center" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Direction__subtitle mr-2" }, "Родительские направления", -1))
const _hoisted_79 = { class: "Direction__counter" }
const _hoisted_80 = {
  key: 0,
  class: "InternationalDirections mt-3"
}
const _hoisted_81 = { class: "min-w-full" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "text-center font-semibold" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Наименование"),
    /*#__PURE__*/_createElementVNode("th", null, "Код 1С"),
    /*#__PURE__*/_createElementVNode("th", null, "Зона доставки"),
    /*#__PURE__*/_createElementVNode("th", null, "Логист"),
    /*#__PURE__*/_createElementVNode("th", null, "Статус"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_83 = { class: "text-sm" }
const _hoisted_84 = { class: "Direction__link" }
const _hoisted_85 = { class: "flex justify-center" }
const _hoisted_86 = {
  key: 0,
  class: "Direction__counter"
}
const _hoisted_87 = { class: "MainText" }
const _hoisted_88 = {
  key: 0,
  class: "Hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_directions_import_internal = _resolveComponent("directions-import-internal")!
  const _component_directions_tms_actions = _resolveComponent("directions-tms-actions")!
  const _component_add_subdirection_modal = _resolveComponent("add-subdirection-modal")!
  const _component_delete_subdirection_modal = _resolveComponent("delete-subdirection-modal")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_city_from_icon = _resolveComponent("city-from-icon")!
  const _component_city_to_icon = _resolveComponent("city-to-icon")!
  const _component_zone_icon = _resolveComponent("zone-icon")!
  const _component_one_c_icon = _resolveComponent("one-c-icon")!
  const _component_logist_icon = _resolveComponent("logist-icon")!
  const _component_parent_icon = _resolveComponent("parent-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_status_icon = _resolveComponent("status-icon")!
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_import_icon = _resolveComponent("import-icon")!
  const _component_deattach_icon = _resolveComponent("deattach-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_excel)
      ? (_openBlock(), _createBlock(_component_directions_import_internal, {
          key: 0,
          direction: _ctx.pageTitle,
          parentDirectionId: _ctx.state.direction.id,
          onSubmit: _ctx.toggleExcel,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false))
        }, null, 8, ["direction", "parentDirectionId", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_directions_tms_actions, {
          key: 1,
          loading: _ctx.actions_state.is_actions_loading,
          "is-update": true,
          "initial-value": _ctx.actions_state.initial_value,
          onUpdate: _ctx.updateDirection,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.actions_state.is_actions_opened = false))
        }, null, 8, ["loading", "initial-value", "onUpdate"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_add_direction)
      ? (_openBlock(), _createBlock(_component_add_subdirection_modal, {
          key: 2,
          loading: _ctx.state.is_loading,
          parent: _ctx.pageTitle,
          onSubmit: _ctx.addSubdirection,
          onCancel: _ctx.toggleAddSubdirection
        }, null, 8, ["loading", "parent", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.delete_state.is_open)
      ? (_openBlock(), _createBlock(_component_delete_subdirection_modal, {
          key: 3,
          loading: _ctx.state.is_loading,
          parent: _ctx.delete_state.parent,
          child: _ctx.delete_state.child,
          "is-child": _ctx.delete_state.is_child,
          onSubmit: _ctx.deleteSubdirection,
          onCancel: _ctx.resetDeleteState
        }, null, 8, ["loading", "parent", "child", "is-child", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_loading || _ctx.state.is_failed || !_ctx.state.direction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary"
              }))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_3,
                  _createVNode(_component_new_button, {
                    class: "mt-3",
                    onClick: _ctx.loadDirection
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Обновить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (!_ctx.state.direction)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" Нет данных ")
                  ], 64))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_page_title, {
                title: _ctx.pageTitle,
                class: "mr-2"
              }, null, 8, ["title"]),
              (_ctx.isParent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_new_button, {
                class: "primary mr-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startUpdate(_ctx.state.direction)))
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _createTextVNode(" Редактировать ")
                ]),
                _: 1
              }),
              _createVNode(_component_new_button, {
                class: "NewButton--reset",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/tms/directions')))
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _createTextVNode(" Назад ")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["Direction__box Direction__general", { Direction__full: !_ctx.state.is_sla }])
            }, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_city_from_icon, { class: "mr-2" }),
                  _createTextVNode(" Город отправления ")
                ]),
                (_ctx.state.direction.fromCity)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.state.direction.fromCity.name), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, "-")),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_city_to_icon, { class: "mr-2" }),
                  _createTextVNode(" Город назначения ")
                ]),
                (_ctx.state.direction.whereCity)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.state.direction.whereCity.name), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, "-")),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_zone_icon, { class: "mr-2" }),
                  _createTextVNode(" Зона доставки ")
                ]),
                (_ctx.state.direction.zone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.state.direction.zone.description) + " [" + _toDisplayString(_ctx.state.direction.zone.number) + "] ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, "-")),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_one_c_icon, { class: "mr-2" }),
                  _createTextVNode(" Код 1С ")
                ]),
                _createElementVNode("div", null, _toDisplayString(_ctx.state.direction.code), 1),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_logist_icon, { class: "mr-2" }),
                  _createTextVNode(" Логист ")
                ]),
                _createElementVNode("div", null, _toDisplayString(_ctx.state.direction.logistName || '-'), 1),
                (_ctx.isInternal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode(_component_parent_icon, { class: "mr-2" }),
                      _createTextVNode(" Родитель ")
                    ]))
                  : _createCommentVNode("", true),
                (
                                _ctx.isInternal &&
                                _ctx.state.direction.parentDirections &&
                                _ctx.state.direction.parentDirections.length
                            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.direction.parentDirections, (parentDirection, idx) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: `parentDirection-${idx}`,
                          class: "nowrap"
                        }, [
                          _createVNode(_component_router_link, {
                            class: "text-blue-500",
                            to: `/tms/directions/${parentDirection.id}`,
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(parentDirection.fromCity.name) + " - " + _toDisplayString(parentDirection.whereCity.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          (idx + 1 !== _ctx.state.direction.parentDirections.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, " ,"))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_status_icon, { class: "mr-2" }),
                  _createTextVNode(" Статус ")
                ]),
                _createElementVNode("div", null, _toDisplayString(_ctx.state.direction.isActive ? 'Активно' : 'Не активно'), 1)
              ])
            ], 2),
            (_ctx.state.is_sla)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createVNode(_component_radio_group, {
                      class: "small mt-2",
                      name: "sla_tab",
                      value: _ctx.state.current_tab_sla,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.current_tab_sla) = $event)),
                      options: _ctx.SLA_TABS
                    }, null, 8, ["value", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    (_ctx.isLtlSla)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_38,
                              _hoisted_39,
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 1, 'Стандарт')?.pickup), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 1, 'Стандарт')?.processing), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 1, 'Стандарт')?.transit), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 1, 'Стандарт')?.delivery), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_40,
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 2, 'Стандарт')?.pickup), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 2, 'Стандарт')?.processing), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 2, 'Стандарт')?.transit), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 2, 'Стандарт')?.delivery), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_41,
                              _hoisted_42,
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 1)?.pickup), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 1)?.processing), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 1)?.transit), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 1)?.delivery), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_43,
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 2)?.pickup), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 2)?.processing), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 2)?.transit), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ltl', 2)?.delivery), 1)
                            ])
                          ])
                        ]))
                      : (_ctx.isFtlSla)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_44, [
                            _hoisted_45,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_46,
                                _hoisted_47,
                                _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ftl', 1)?.pickup), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ftl', 1)?.processing), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ftl', 1)?.transit), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ftl', 1)?.delivery), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_48,
                                _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ftl', 2)?.pickup), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ftl', 2)?.processing), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ftl', 2)?.transit), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.getSla('ftl', 2)?.delivery), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (
                    _ctx.state.direction.costStandard &&
                    _ctx.state.direction.costStandard[0] &&
                    _ctx.state.direction.costStandard[0].capacities &&
                    _ctx.state.direction.costStandard[0].capacities.length
                )
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("table", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.direction.costStandard[0]
                                        .capacities, (capacity, i) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: `capacity-${i}`
                          }, [
                            _createElementVNode("div", _hoisted_54, [
                              _hoisted_55,
                              _createTextVNode(_toDisplayString(capacity.costPerWeight), 1)
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                              _hoisted_57,
                              _createTextVNode(_toDisplayString(capacity.costPerCubature), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.direction.internalDirections)
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.state.direction.internalDirections.length), 1)
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_new_button, {
                      class: "primary mr-2",
                      onClick: _ctx.toggleExcel
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_import_icon, { class: "mr-2" }),
                        _createTextVNode(" Импортировать ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_new_button, {
                      class: "primary",
                      onClick: _ctx.toggleAddSubdirection
                    }, {
                      default: _withCtx(() => [
                        _hoisted_64,
                        _createTextVNode(" Добавить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    (_ctx.isInternal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, " Открепите текущее направление от родительского для добавления дочерних "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.state.direction.internalDirections.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                      _createElementVNode("table", _hoisted_67, [
                        _hoisted_68,
                        _createElementVNode("tbody", _hoisted_69, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.direction.internalDirections, (direction, idx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: `internationalDirection-${idx}`,
                              class: "border-b"
                            }, [
                              _createElementVNode("td", _hoisted_70, [
                                (direction.fromCity && direction.whereCity)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "text-blue-500",
                                      to: `/tms/directions/${direction.directionId}`,
                                      target: "_blank"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.dirName(direction)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(direction.code), 1),
                              _createElementVNode("td", _hoisted_71, [
                                (direction.zone)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                      _createElementVNode("div", _hoisted_73, _toDisplayString(direction.zone.number), 1),
                                      (direction.zone.description)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(direction.zone.description), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(direction.logistName), 1),
                              _createElementVNode("td", {
                                class: _normalizeClass(direction.isActive ? 'text-green-500' : 'text-red-500')
                              }, _toDisplayString(direction.isActive ? 'Активно' : 'Не активно'), 3),
                              _createElementVNode("td", null, [
                                _createVNode(_component_new_button, {
                                  class: "deattachBtn",
                                  onClick: ($event: any) => (
                                            _ctx.toggleDeleteSubdirection(
                                                direction.directionId,
                                                _ctx.dirName(direction),
                                                _ctx.pageTitle
                                            )
                                        )
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_deattach_icon)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.direction.parentDirections)
            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.state.direction.parentDirections.length), 1)
                  ])
                ]),
                (_ctx.state.direction.parentDirections.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("table", _hoisted_81, [
                        _hoisted_82,
                        _createElementVNode("tbody", _hoisted_83, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.direction.parentDirections, (direction, idx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: `internationalDirection-${idx}`,
                              class: "border-b"
                            }, [
                              _createElementVNode("td", _hoisted_84, [
                                (direction.fromCity && direction.whereCity)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "text-blue-500",
                                      to: `/tms/directions/${direction.id}`,
                                      target: "_blank"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.dirName(direction)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(direction.code), 1),
                              _createElementVNode("td", _hoisted_85, [
                                (direction.zone)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                      _createElementVNode("div", _hoisted_87, _toDisplayString(direction.zone.number), 1),
                                      (direction.zone.description)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(direction.zone.description), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(direction.logistName), 1),
                              _createElementVNode("td", {
                                class: _normalizeClass(direction.isActive ? 'text-green-500' : 'text-red-500')
                              }, _toDisplayString(direction.isActive ? 'Активно' : 'Не активно'), 3),
                              _createElementVNode("td", null, [
                                _createVNode(_component_new_button, {
                                  class: "deattachBtn",
                                  onClick: ($event: any) => (
                                            _ctx.toggleDeleteSubdirection(
                                                direction.id,
                                                _ctx.dirName(direction),
                                                _ctx.pageTitle,
                                                'child'
                                            )
                                        )
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_deattach_icon)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}